import styled from 'styled-components/macro';
import { FieldErrorIndicator } from '../../../../shared/form/FieldErrorIndicator';
import { Header2 } from '../../../../shared/Headers';
import { colourRed06, colourYellow06 } from '../../../../styling/colours';
import { spacing02 } from '../../../../styling/spacing';
import { getMapDisplayStatus } from './map-helpers/mapHelpers';
import { TreeStatus } from './map-helpers/treeValidator';

type Props = {
  treeStatus: TreeStatus;
};
export const MapStatus = ({ treeStatus }: Props) => {
  const mapStatus = getMapDisplayStatus(treeStatus);
  return (
    <MapStatusContainer>
      <Header2>{mapStatus.status}</Header2>
      <MapErrorIndicator
        fieldName="mapStatus"
        error={mapStatus.errorMessage}
        $isWarning={mapStatus.status === 'Map Incomplete'}
        showError={mapStatus.showErrorIndicator}
      />
    </MapStatusContainer>
  );
};

const MapStatusContainer = styled.div`
  display: flex;
  align-items: baseline;
`;

const MapErrorIndicator = styled(FieldErrorIndicator)<{ $isWarning: boolean }>`
  color: ${props => (props.$isWarning ? colourYellow06 : colourRed06)};
  margin-left: ${spacing02};
`;
